import React from 'react';
import { Typography } from '@mui/material';

type MessageProps = {
  message: any;
};

const Message: React.FC<MessageProps> = ({ message }) => {
  try {
    const formatText = (input: any): string => {
      if (!input) return 'Text message not found';

      let text = typeof input === 'object'
        ? JSON.stringify(input, null, 2)
        : input.toString();

      // ✅ Bold (**text**)
      text = text.replace(/\*(.*?)\*/g, '<b>$1</b>');

      // ✅ Italic (_text_)
      text = text.replace(/_(.*?)_/g, '<i>$1</i>');

      // ✅ Convert URLs to clickable links
      text = text.replace(
        /(https?:\/\/[^\s]+)/g,
        '<a href="$1" target="_blank" style="color:#1976d2;text-decoration:underline;">$1</a>'
      );

      // ✅ Handle line breaks
      text = text.replace(/\n/g, '<br/>');

      return text;
    };

    const formattedText = formatText(
      message?.content?.body?.text || message?.content?.text
    );

    return (
      <Typography
        variant="body1"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          lineHeight: 1.5, // ✅ FIXED
          fontSize: '0.95rem',
        }}
        dangerouslySetInnerHTML={{ __html: formattedText }}
      />
    );
  } catch (error) {
    return <div>Text message not found</div>;
  }
};

export default Message;